import _ from 'lodash';
import React from 'react';
/**
 * Checks if the given child is a React text node.
 */
export var isReactText = function (child) {
    return ['string', 'number'].includes(typeof child);
};
/**
 * A hook to manage the tooltip trigger state.
 */
export var useTooltipTrigger = function (_a) {
    var delayEnter = _a.delayEnter, delayLeave = _a.delayLeave;
    var _b = React.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    /** User hovered over the trigger. */
    var triggerEnterTimeoutRef = React.useRef(null);
    /** User moved the pointer away from the trigger. */
    var triggerLeaveTimeoutRef = React.useRef(null);
    /** User moved the pointer away from the content. */
    var contentLeaveTimeoutRef = React.useRef(null);
    /**
     * Handles the event when the user hovers over the trigger.
     */
    var handleTriggerMouseEnter = function () {
        if (triggerLeaveTimeoutRef.current) {
            // The user moved the pointer away from the trigger and then back again.
            // We should cancel the leave timeout aka don't close the tooltip.
            clearTimeout(triggerLeaveTimeoutRef.current);
            triggerLeaveTimeoutRef.current = null;
        }
        if (contentLeaveTimeoutRef.current) {
            // The user moved the pointer away from the content and then into the trigger.
            // We should cancel the leave timeout aka don't close the tooltip.
            clearTimeout(contentLeaveTimeoutRef.current);
            contentLeaveTimeoutRef.current = null;
        }
        // The user hovered over the trigger. We should open the tooltip after the (optional) delay.
        triggerEnterTimeoutRef.current = setTimeout(function () {
            setIsOpen(true);
        }, _.defaultTo(delayEnter, 0));
    };
    /**
     * Handles the event when the user moves the pointer away from the trigger.
     */
    var handleTriggerMouseLeave = function () {
        if (triggerEnterTimeoutRef.current) {
            // The user moved the pointer into the trigger and then away.
            // We should cancel the enter timeout aka don't open the tooltip.
            clearTimeout(triggerEnterTimeoutRef.current);
            triggerEnterTimeoutRef.current = null;
        }
        // We should close the tooltip after the (optional) delay.
        triggerLeaveTimeoutRef.current = setTimeout(function () {
            setIsOpen(false);
        }, _.defaultTo(delayLeave, 200));
    };
    /**
     * Handles the event when the user hovers over the content.
     */
    var handleContentMouseEnter = function () {
        if (triggerLeaveTimeoutRef.current) {
            // The user moved the pointer away from the trigger and then into the content.
            // We should cancel the leave timeout aka don't close the tooltip.
            clearTimeout(triggerLeaveTimeoutRef.current);
            triggerLeaveTimeoutRef.current = null;
        }
        if (contentLeaveTimeoutRef.current) {
            // The user moved the pointer away from the content and then back into it.
            // We should cancel the leave timeout aka don't close the tooltip.
            clearTimeout(contentLeaveTimeoutRef.current);
            contentLeaveTimeoutRef.current = null;
        }
    };
    /**
     * Handles the event when the user moves the pointer away from the content.
     */
    var handleContentMouseLeave = function () {
        contentLeaveTimeoutRef.current = setTimeout(function () {
            setIsOpen(false);
        }, _.defaultTo(delayLeave, 0));
    };
    return {
        isOpen: isOpen,
        triggerProps: {
            onMouseEnter: handleTriggerMouseEnter,
            onMouseLeave: handleTriggerMouseLeave,
            onTouchStart: handleTriggerMouseEnter,
            onTouchEnd: handleTriggerMouseLeave,
        },
        contentProps: {
            onMouseEnter: handleContentMouseEnter,
            onMouseLeave: handleContentMouseLeave,
            onTouchStart: handleContentMouseEnter,
            onTouchEnd: handleContentMouseLeave,
        },
    };
};
